export const difficultiesList = () => {
    return [
        {
            id: 1,
            name: 'Baja'
        },
        {
            id: 2,
            name: 'Media'
        },
        {
            id: 3,
            name: 'Alta'
        }
    ]
};